import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

type DataType = {
  roomId: string
  add?: string[]
  remove?: string[]
}

class SetRoomProductTopApi extends Service {
  constructor(data: DataType) {
    super()
    this.name = 'SET_ROOM_PRODUCT_TOP'

    // shop-api 的 add/remove 是 repeated int32（shop-api-idl api/room/room.proto:653 TopProductRequest），
    // 但前端的 productId 一路都是 string，直接送會被擋成 -5「cannot unmarshal string into ... int32」
    this.config = {
      url: `/v1/room/top-product`,
      method: 'POST',
      data: {
        ...data,
        ...(data.add && { add: data.add.map(Number) }),
        ...(data.remove && { remove: data.remove.map(Number) }),
      },
    }
  }
}

export const setRoomProductTop = (data: DataType) => getCallApiFunction(new SetRoomProductTopApi(data))
